export default __webpack_public_path__ + "static/delegator@2x-5cd167e30d34372d59a60b5fc7b1f0b2.png";